import WithDirection from '@app/settings/withDirection';
import { Dropdown } from 'antd';
import { DropdownWrapper } from './styles/dropdown.style';

const WDDropdowns = DropdownWrapper(Dropdown);
const WDDropdownButtons = DropdownWrapper(Dropdown.Button);

export const IsoDropdown = WithDirection(WDDropdowns);
export const IsoDropdownButtons = WithDirection(WDDropdownButtons);
